import { render, staticRenderFns } from "./SnakeGame.vue?vue&type=template&id=67927950&data-test-id=snakeGameView&"
import script from "./SnakeGame.vue?vue&type=script&lang=js&"
export * from "./SnakeGame.vue?vue&type=script&lang=js&"
import style0 from "./SnakeGame.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports